module.exports = __webpack_public_path__ + "static/img/user.1781503650204.png";